module.exports = __webpack_public_path__ + "src/assets/img/guest_restaurant.7e113ea0.jpg";